import { format, isSameDay, differenceInHours } from "date-fns";
import { DateFormats } from "helpers/dates";

function dropLastCharacter(initial: string): string {
  return initial.slice(0, -1);
}

function formatDateRange(startTime: Date, endTime: Date) {
  return `${dropLastCharacter(
    format(startTime, DateFormats.TIME_COMPRESSED)
  )} - ${dropLastCharacter(format(endTime, DateFormats.TIME_COMPRESSED))}`;
}

function getHourLabel(hour: Date, includeAMPM: boolean) {
  const formatted = format(hour, includeAMPM ? "hA" : "h");
  return includeAMPM ? dropLastCharacter(formatted) : formatted;
}

function isAllDay(startTime: Date, endTime: Date) {
  return (
    isSameDay(startTime, endTime) && differenceInHours(endTime, startTime) >= 23
  );
}

export { dropLastCharacter, formatDateRange, getHourLabel, isAllDay };
